/**
 * Analytics utility for centralized event tracking
 *
 * Provides a single point of control for analytics across the application.
 * If analytics implementation changes (provider, schema, etc.),
 * only this file needs to be updated.
 */

// Window analytics interface
interface AnalyticsWindow extends Window {
    analytics?: {
        track?: (name: string, props?: Record<string, unknown>) => void;
    };
}

/**
 * Track an analytics event
 * @param eventName - Name of the event to track
 * @param properties - Optional event properties
 */
export function trackEvent(
    eventName: string,
    properties?: Record<string, unknown>,
): void {
    const analytics = (window as AnalyticsWindow).analytics;
    analytics?.track?.(eventName, properties);
}
